import { Box, BoxProps } from "@chakra-ui/react";
import { APP_FULL_HEIGHT_CONTENT_HEIGHT } from "components/Layout/constants";

type Props = BoxProps;

export default function FullHeightContent(props: Props) {
  return (
    <Box
      height={APP_FULL_HEIGHT_CONTENT_HEIGHT}
      id="FullHeightContent"
      minH={0}
      overflow="hidden"
      {...props}
    />
  );
}
